import Api from '@/services/api';
import qs from 'querystring';

export default {
  search_old(search, status, base, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false) {

    return Api().post('/payments/search', qs.stringify({
      'search': encodeURIComponent(search),
      'status': status,
      'base': base,
      'filters': JSON.stringify(filters),
      'hiddenFilter' : hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
    }));
  },
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'name', sortDesc = false, fetchFacets = true) {

    return Api().post('/payments/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  get(id) {
    return Api().get('/payment/' + id);
  },
  delete(id) {
    return Api().delete('/payment/' +id);
  },
  delete_payment(data) {
    return Api().delete('/warrant/' + data.warrant_id + '/payment/' + data.payment_id);
  },
  update_payment(data) {
    return Api().post('/warrant/' + data.warrant_id + '/payment/' + data.payment_id, qs.stringify({ data: JSON.stringify(data.payment) }));    
  },
  create_payment(data) {
    return Api().post('/warrant/' + data.warrant_id + '/payment', qs.stringify({ data: JSON.stringify(data.payment) }));    
  },
  payment(data) {
    return Api().get('/warrant/' + data.warrant_id + '/payment/' + data.payment_id);
  },
  getFlow(start = null, end = null) {
    return Api().get('/payments/flow?start=' + start + '&end=' + end);
  }

}